import useLocking from './useLocking';

export default useLocking;
